// contactform.js
import $ from 'jquery';
import './newContactForm'
import './searchOffice'


import {
    Chart,
    DoughnutController,
    ArcElement,
    Legend,
    Tooltip
} from 'chart.js';

Chart.register(DoughnutController, ArcElement, Legend, Tooltip);

const charts = [];

(function () {

    $(document).ready(() => {

        let cookie = getCookie('hide-title');

        if (cookie) {
            $('#floating-contact-form h4.hidden-xs').hide();
        }

        $('.contact-form').on('submit', function (e) {

            if ($(this).hasClass('normal-contact')) {
                setCookie('hide-title', true, 1);
            }

        })


        // Close success msg
        $('.contact-form').on('click', '.form-success-msg .close-link', (e) => {

            e.preventDefault();

            const $form = $(e.currentTarget).closest('.contact-form');

            // Dölj hela formuläret om URL innehåller success=true på små skärmar
            if (window.location.search.substr(1).includes('success=true') && window.innerWidth <= 991) {
                $form.hide();
            }

            // Dölj success-meddelandet
            $form.find('.form-success-msg').fadeOut();

            // Återställ knappar och rubriker
            $('#floating-contact-form .contact-form button.btn').attr('disabled', false);
            eraseCookie('hide-title');
            $('#floating-contact-form h4.hidden-xs').show();

            // Rensa URL-param om success=true
            if (window.location.search.substr(1).includes('success=true')) {
                window.history.pushState({}, document.title, window.location.origin + window.location.pathname);
            }

        });

        // Message box expand
        $('.contact-form').on('focus', 'textarea', (e) => {
            $(e.currentTarget).css({
                height: '235px',
                overflowY: 'auto'
            });
        });


        /************
         * Contact form franchise
         ************/

        // CV file upload
        $('.contact-form-upload-file').on('change', (e) => {
            $(e.target).parent().parent().find('.contact-form-upload-filename').val(e.target.files[0].name)
        })

        renderDoughnutCharts()
    })

})()


function renderDoughnutCharts() {

    const circlesCharts = document.querySelectorAll('.charts .doughnut-chart');

    if (circlesCharts.length > 0) {

        circlesCharts.forEach((element) => {

            if (element.childNodes.length) {

                const canvas = Array.from(element.childNodes).find((el) => el.tagName === 'CANVAS')

                if (canvas) {

                    renderCircleChart(
                        canvas,
                        element.dataset.percent,
                        element.dataset.color,
                        element.dataset.label,
                        '50%'
                    );
                }
            }

        })

        let resizeTimeout;

        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                charts.forEach(c => c.update());
            }, 200);
        });

    }

}


function renderCircleChart(element, percent, color, labels, cutOut = '92%') {

    percent = parseFloat(percent);

    var plugin = {

        id: 'centerTextPlugin', // Ändrade 'elements' till unikt namn

        beforeDraw: function (chart) {

            const centerConfig = chart.options.plugins.centerTextPlugin;

            if (centerConfig) {

                var ctx = chart.ctx;

                //Get options from the center object in options
                var fontStyle = centerConfig.fontStyle || 'Arial';
                var txt = centerConfig.text;
                var color = centerConfig.color || '#000';
                var sidePadding = centerConfig.sidePadding || 20;
                var sidePaddingCalculated =
                    (sidePadding / 100) * (chart.innerRadius * 2);

                ctx.font = '20px ' + fontStyle;

                //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
                var stringWidth = ctx.measureText(txt).width;
                var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

                // Find out how much the font can grow in width.
                var widthRatio = elementWidth / stringWidth;
                var newFontSize = Math.floor(30 * widthRatio);
                var elementHeight = chart.innerRadius * 2;

                // Pick a new font size so it will not be larger than the height of label.
                var fontSizeToUse = Math.min(newFontSize, elementHeight);

                //Set font settings to draw it correctly.
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
                var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
                ctx.font = fontSizeToUse + 'px ' + fontStyle;
                ctx.fillStyle = color;

                //Draw text in center
                ctx.fillText(txt, centerX, centerY);
            }
        },
    }

    const data = {
        labels: labels.split(','),
        datasets: [
            {
                data: [percent, 100 - percent],
                backgroundColor: [
                    `rgba(27, 128, 109, 1)`,
                    `rgba(27, 128, 109, 0.15)`,
                ],
                borderWidth: 0, // Enkel int för alla kanter
            },
        ],
    };

    const options = {
        cutout: cutOut,
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return `${percent}%`;
                    },
                },
            },
            // Anpassa options för ditt centerTextPlugin
            centerTextPlugin: {
                text: percent + '%',
                color: color,
                fontStyle: 'Helvetica Now Text, Helvetica, Arial, sans serif',
                sidePadding: 20,
            },
        },

    };

    const config = {
        type: 'doughnut',
        data,
        options,
        plugins: [plugin]
    };


    let myChart = new Chart(element, config);

    charts.push(myChart);
};


function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function eraseCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
}